/**
* Description:  常见数据格式正则
* @author: lhc
* @date: 2022/1/10 15:35
*/
export default {


  _NUMBER: `^(0|([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*))$`,

  /**
   * Description: 自然数
   * @author: lhc
   * @date: 2022/1/9 19:06
   *  ^(0|([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*))$"
   */
  _NATURAL_NUMBER: `^\\+?[1-9][0-9]*$`,

  /**
   * Description: 校验中文姓名和英文姓名
   * @author: lhc
   * @date: 2022/1/9 19:07
   */
  _NAME: `(([\u4E00-\u9FA5·]{1,17})|([a-zA-Z]{1,17}))`,


  /**
   * Description:  身份证号(15位、18位数字)，最后一位是校验位，可能为数字或字符X
   * @author: lhc
   * @date: 2022/1/10 15:06
   */
  _IDCard: `(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)`,

  /**
   * Description: 18位身份证号
   * @author: lhc
   * @date: 2022/1/9 19:41
   */
  _18_IDCard: `^[1-9]\\d{5}[1-9]\\d{3}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])\\d{3}([0-9]|X|x)$`,

  /**
   * Description:15位身份证号
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _15_IDCard: `^[1-9]\\d{7}((0\\[1-9])|(1[0-2]))(([0\\[1-9]|1\\d|2\\d])|3[0-1])\\d{2}([0-9]|x|X){1}$`,

  /**
   * Description: URL
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _URL: `(http|https):\\/\\/([\\w.]+\\/?)\\S*`,

  /**
   * Description: 腾讯QQ号(腾讯QQ号从10000开始)
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _QQ: `[1-9][0-9]{4,}`,

  /**
   * Description: 一个或多个汉字
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _CHINESE: `^[\u4E00-\u9FA5]+$`,

  /**
   * Description: 手机号码
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _MOBILE_PHONE: `^1[3|4|5|8][0-9]\\d{8}$`,

  /**
   * Description: 所有电话格式校验
   * @author: lhc
   * @date: 2022/1/9 19:42
   */
  _ALL_PHONE: `^((1[0,1,2,3,4,5,6,7,8,9]))\\d{9}|((\\d{4})?(\\-)?\\d{7})$`,


  /**
   * Description: 邮箱验证
   * @author: lhc
   * @date: 2022/1/9 19:43
   */
  _MAIL: `^[A-Za-z0-9\\u4e00-\\u9fa5]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$`,

  /**
   * Description: 邮政编码
   * @author: lhc
   * @date: 2022/1/9 19:43
   */
  _POST_CODE: `^[1-9]\\d{5}$`,


  /**
   * Description: 域名
   * @author: lhc
   * @date: 2022/1/10 15:00
   */
  _DOMAIN: `[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?`,

  /**
   * Description: InternetURL
   * @author: lhc
   * @date: 2022/1/10 15:00
   */
  _NET_URL_1: `[a-zA-z]+:\\/\\/[^\\s]*`,

  _NET_URL_2: `^http:\\/\\/([\\w-]+\\.)+[\\w-]+(\\/[\\w-./?%&=]*)?$`,

  /**
   * Description: 手机号码
   * @author: lhc
   * @date: 2022/1/10 15:01
   */
  _MOBILE_PHONE_1: `^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\\d{8}$`,

  /**
   * Description: 电话号码正则表达式（支持手机号码，3-4位区号，7-8位直播号码，1-4位分机号）
   * @author: lhc
   * @date: 2022/1/10 15:05
   */
  _MOBILE_PHONE_2: `((\\d{11})|^((\\d{7,8})|(\\d{4}|\\d{3})-(\\d{7,8})|(\\d{4}|\\d{3})-(\\d{7,8})-(\\d{4}|\\d{3}|\\d{2}|\\d{1})|(\\d{7,8})-(\\d{4}|\\d{3}|\\d{2}|\\d{1}))$)`,


  /**
   * Description: 电话号码   ("XXX-XXXXXXX"、"XXXX-XXXXXXXX"、"XXX-XXXXXXX"、"XXX-XXXXXXXX"、"XXXXXXX"和"XXXXXXXX)
   * @author: lhc
   * @date: 2022/1/10 15:02
   */
  _TELEPHONE: `^((\\d{3,4}-)|\\d{3.4}-)?\\d{7,8}$`,

  /**
   * Description: 国内电话号码(0511-4405222、021-87888822)
   * @author: lhc
   * @date: 2022/1/10 15:04
   */
  _CHINA_PHONE: `\\d{3}-\\d{8}|\\d{4}-\\d{7}`,


  /**
   * Description: 帐号是否合法(字母开头，允许5-16字节，允许字母数字下划线)
   * @author: lhc
   * @date: 2022/1/10 15:07
   */
  _ACCOUNT: `^[a-zA-Z][a-zA-Z0-9_]{4,15}$`,

  /**
   * Description:  密码(以字母开头，长度在6~18之间，只能包含字母、数字和下划线)
   * @author: lhc
   * @date: 2022/1/10 15:08
   */
  _PASSWORD: `^[a-zA-Z]\\w{5,17}$`,

  /**
   * Description:  强密码(必须包含大小写字母和数字的组合，不能使用特殊字符，长度在 8-10 之间)
   * @author: lhc
   * @date: 2022/1/10 15:09
   */
  _S_PASSWORD_1: `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,10}$`,

  /**
   * Description: 强密码(必须包含大小写字母和数字的组合，可以使用特殊字符，长度在8-10之间)
   * @author: lhc
   * @date: 2022/1/10 15:09
   */
  _S_PASSWORD_2: `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$`,

  /**
   * Description:  日期格式 0000-00-00
   * @author: lhc
   * @date: 2022/1/10 15:11
   */
  _DATE_YYYY_MM_DD: `^\\d{4}-\\d{1,2}-\\d{1,2}`,

  /**
   * Description: 一年的12个月(01～09和1～12)
   * @author: lhc
   * @date: 2022/1/10 15:11
   */
  _DATE_MONTH: `^(0?[1-9]|1[0-2])$`,

  /**
   * Description: 一个月的31天(01～09和1～31)
   * @author: lhc
   * @date: 2022/1/10 15:12
   */
  _DATE_DAY: `^((0?[1-9])|((1|2)[0-9])|30|31)$`,

  /**
   * Description: 钱的四种的表示形式:"10000.00"、"10,000.00"、没有 "分"的"10000"、"10,000"
   * @author: lhc
   * @date: 2022/1/10 15:13
   */
  _MONEY: `^[1-9][0-9]*$`,

  /**
   * Description:  xml文件
   * @author: lhc
   * @date: 2022/1/10 15:14
   */
  _XML: `^([a-zA-Z]+-?)+[a-zA-Z0-9]+\\.[x|X][m|M][l|L]$`,

  /**
   * Description: 中文字符的正则表达式
   * @author: lhc
   * @date: 2022/1/10 15:14
   */
  _CHINESE_CHAR: `[\u4e00-\u9fa5]`,

  /**
   * Description:空白行的正则表达式
   * @author: lhc
   * @date: 2022/1/10 15:15
   */
  _BLANK_LINE: `\\n\\s*\\r`,

  /**
   * Description: HTML标记的正则表达式
   * @author: lhc
   * @date: 2022/1/10 15:15
   */
  _HTML: `<(\\S*?)[^>]*>.*?|<.*? \\/>`,

  /**
   * Description: IPv4地址
   * @author: lhc
   * @date: 2022/1/10 15:18
   */

  _IPv4: `((2(5[0-5]|[0-4]\\d))|[0-1]?\\d{1,2})(\\.((2(5[0-5]|[0-4]\\d))|[0-1]?\\d{1,2})){3}`,

}


